// Alt brukerstyrt innhold settes med textContent, aldri innerHTML. Navn og
// e-post kommer fra tokenet, og et navn med markup i skal rendres som tekst.
// Det samme gjelder status.json: den kommer fra en annen bøtte, og innholdet
// skal aldri kunne bli markup her.

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  klasse?: string,
  tekst?: string,
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  if (klasse) node.className = klasse;
  if (tekst !== undefined) node.textContent = tekst;
  return node;
}

/** #app, tømt og klar til å tegnes i. */
export function rot(): HTMLElement {
  const node = document.getElementById("app");
  if (!node) throw new Error("Fant ikke #app i index.html");
  node.replaceChildren();
  return node;
}
